import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import ModalPopupScreen from '../../ModalScreen/ModalPopupScreen';
import { auth_token, authority_msg, put_volunteer_url } from '../../WebController/WebController';
import DashInsertVolunteer from '../DashInsertVolunteer/DashInsertVolunteer';

const DashVolunteer = () => {
    const [volunteerList, setVolunteerList] = useState([]);
    const [insert, setInsert] = useState(false);
    const [update, setUpdate] = useState(false);
    const [state, setState] = useState("");
    const [id, setId] = useState(0);
    const [authToken, setAuthToken] = useState("");


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        const auth_token_value = sessionStorage.getItem('auth_token');
        setAuthToken(auth_token_value);
        fetchVolunteerListData(auth_token_value);
    }, []);

    const fetchVolunteerListData = (auth_token_value) => {
        const formData = new FormData();
        formData.append("state", "2");
        formData.append(auth_token, auth_token_value);

        fetch(put_volunteer_url, {
            method: "POST",
            body: formData,
        })
            .then((res) => res.json())
            .then((data) => {
                if (!data.error) {
                    setVolunteerList(data.data);
                }

            })
            .catch((error) => {
                console.log(authority_msg);
            });
    }
    const handleLoad = () => {
        setInsert(false);
        setUpdate(false);
        fetchVolunteerListData(authToken);
    }

    const handleInsert = () => {
        setState("Insert");
        setInsert(true);
    }


    const handleUpdate = (id) => {
        setState("Update");
        setId(id);
        setUpdate(true);
    }

    const handleDelete = (id) => {
        openModal();
        setId(id);

    }

    const popupCloseSubmit = () => {
        setIsModalOpen(false);
        const formData = new FormData();
        formData.append(auth_token, authToken);
        formData.append("state", "4");
        formData.append("id", id);
        fetch(put_volunteer_url, {
            method: "POST",
            body: formData,
        })
            .then((res) => res.json())
            .then((data) => {
                fetchVolunteerListData(authToken);

            })
            .catch((error) => {
                console.log(authority_msg);
            });
    }
    const mainDiv = () => {
        return (
            <div>
                <div className='row align-items-center '>
                    <div className='col-md-10 text-center align-self-center'><p className=' title-p'>Volunteer</p></div>
                    <div className='col-md-2 text-right'>
                        <button className='buttonStyle' onClick={() => { handleInsert() }}>
                            + Add
                        </button>
                    </div>
                </div>

                <table className="table table-bordered table-striped">
                    <thead className=" font-weight-bold thead-item">
                        <tr className='text-center'>
                            <th className=' th-id'>Id</th>
                            <th className=''>Name(English)</th>
                            <th className=''>Name(Bangla)</th>
                            <th className=''>Address(Eng)</th>
                            <th className=''>Address(Ban)</th>
                            <th className=''>Phone</th>
                            <th className=''>State</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            volunteerList.map((item, index) => (

                                <tr key={index} className='align-items-center' >
                                    <td className='font-weight-bold'>{index + 1}</td>
                                    <td>{item.name_eng}</td>
                                    <td>{item.name_ban}</td>
                                    <td>{item.address_eng}</td>
                                    <td>{item.address_ban}</td>
                                    <td >{"0" + item.phone}</td>
                                    <td ><div className='row text-center justify-content-center align-items-center icon-div'>
                                        <FontAwesomeIcon onClick={() => handleUpdate(item.id)} className='col-md-12 font-icon' icon={faEdit} /> <br />
                                        <FontAwesomeIcon onClick={() => handleDelete(item.id)} className='col-md-12  font-icon' icon={faTrash} /></div></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

            </div>
        );
    }
    return (
        <div className="container-fluid ">
            <div>
                {
                    insert || update ?
                        <DashInsertVolunteer
                            state={state}
                            handleLoad={handleLoad}
                            vol_id={id}

                        /> : mainDiv()
                }
                <ModalPopupScreen
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    title="Delete"
                    msg="Are you sure, You want to delete this data?"
                    popupCloseSubmit={popupCloseSubmit} />

            </div>
        </div>
    );
};

export default DashVolunteer;